//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import parse from 'date-fns/parse'
//import format from 'date-fns/format'

//import qs from "qs";

export default {
  props: {
    place: {
      default: false
    },
    placeIndex: {

    }
    
  },

  computed: {
    itinerary: function() {
      return this.currentItinerary;
    },
    tourEmbed: function() {
      let embed = false;
      if ( this.place.tour_embed ) {
        embed = this.place.tour_embed
                      .replace('info=1', 'info=0')
                      //.replace('logo=1', 'logo=0')
                      //.replace('fs=0', 'fs=1')
                      .replace('logo=1', 'logo=1&autoplay=1')
                      .replace('640px', '100%')
                      .replace('640', '100%');
        console.log('embed:', embed)
      }
      return embed
    }
  },
  watch: {

  },
  filters: {

  },
  data() {
    return { 
      ui: {
        currentSlide: 0
      },  
      showMenu: false,
      menuOpen: false,
      activeTab: 'images',
      defaultVenueHeight: false,
      venueHeight: false,
      tourIcon: tourIcon,
      glideOptions: {
        perView: 1,
        type: 'carousel',
        
      }

    }
  },
  mounted() {

    this.$nextTick( () => {
      this.venueHeight = '420px';
      this.defaultVenueHeight = '420px';
      this.showMenu = true;
    })
    
    this.$parent.$on('closeTours', (idx) => {
      if (idx !== this.placeIndex) {
        this.toggleTab('images')
      }
    })

  },
  methods: {
    toggleTab(tab) {

      if ( tab == 'tour' ) {
        this.$emit('tourOpened', this.placeIndex)
      }

      this.$nextTick( () => {
        let prevTab = this.activeTab;
        this.activeTab = tab;
        this.menuOpen = false;

        if ( tab == 'tour' && window.innerWidth > 500 ) {
          this.venueHeight = '550px'
        } else {
          this.venueHeight = this.defaultVenueHeight;
        }
      })
      

    },
    getThumbnail(place) {
      //.replace('_o', '_t')
      return 'https://api.everwondr.com'+place.items[0].upload_source.replace('_o.', '_n.');
    },
    fixPhoto(photo) {
      return photo.replace('_o.', '_n.')
    },
    searchPlaces() {
      this.search.page = 1;
      this.places = [];
      this.clearResults = true;

      this.getPlaces();

    },
    togglePlannerItinerary(place) {

      let venue = place;

      if ( place.items.length ) {
        venue.thumbnail = place.items[0].upload_source;
      }

      venue.data_type = 'venue';

      let raw = JSON.stringify( venue );

      //console.log('VENUE____', venue)

      //return false;

      let object = {
        itinerary_id: this.currentSession.id,
        name: venue.name,
        venue_name: null,
        data_type: 'venue',
        object_id: venue.id,
        thumbnail: 'https://api.everwondr.com'+venue.thumbnail,
        address_1: venue.address_1,
        city: venue.city,
        state: venue.state,
        zip: venue.zip,
        lat: venue.lat,
        email: venue.email,
        phone: venue.phone,
        website: venue.website,
        lng: venue.lng,
        raw_object: raw,
        tags: venue.venue_types
      };

      this.toggleItineraryItem(object);

      //this.$store.commit('toggleItinerary', object);

      this.$forceUpdate();

    },
    inPlanner(listing) {
      listing.data_type = 'venue';


      
      listing.object_id = parseInt(listing.id);
      return this.itineraryHasItem(listing);
    },
    
  }
}




// WEBPACK FOOTER //
// ./scripts/components/VirtualTour.vue